
export default {
  name: 'SSwiperElement',
  props: {
    showGuideSwipe: {
      type: Boolean,
      default: false,
    },
    isSwiping: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: true,
    },
    left: {
      type: Number,
      default: null,
    },
  },
  computed: {
    isVirtual() {
      return this.left !== null;
    },
  },
};
